import { render, staticRenderFns } from "./MainSale.vue?vue&type=template&id=83337318&scoped=true"
import script from "./MainSale.vue?vue&type=script&lang=js"
export * from "./MainSale.vue?vue&type=script&lang=js"
import style0 from "./MainSale.vue?vue&type=style&index=0&id=83337318&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83337318",
  null
  
)

export default component.exports